import {CSSProperties} from 'react';
import css from './pagination.module.scss';
import {PaginationProps, SetSelectedStyle} from './pagination.types';

export const Pagination = (props: PaginationProps): JSX.Element => {
	const length = [...Array(props.length).keys()];

	const activeStyle: CSSProperties = {
		backgroundColor: 'var(--color-primary)',
		width: 13,
		height: 8,
	};

	const setSelectedStyle: SetSelectedStyle = (index) => {
		if (index + 1 === props.selected) {
			return {style: activeStyle};
		}
		return {};
	};

	return (
		<div className={css.container}>
			{length.map((item) => {
				return <div {...setSelectedStyle(item)} key={item} className={css.item} data-testid="bullet" />;
			})}
		</div>
	);
};
